// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://kbxmhcysmrjpwaegnuof.supabase.co";
const supabaseAnonKey =
"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtieG1oY3lzbXJqcHdhZWdudW9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5ODQzNTksImV4cCI6MjA4ODU2MDM1OX0.lieaBcOon8FI4XiidFgNTf3kSFKDB8Rzg6-6eTUAYfc";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
